import { ROUTES } from "@/constants/routes";
import { canvasLinkOpenUrl } from "@/pages/canvas/utils/canvasLinkEntity";
import { openCanvasEntityTabUrl } from "@/pages/canvas/utils/resolveCanvasEntityOpenTabUrl";
import { useIsPublicCanvasView } from "@/public-canvas/PublicCanvasArtifactContext";
import { route } from "@/utils/route";
import type { CanvasEntity } from "@cohesive/api-entities";
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Opens a canvas card's linked canvas as a workspace tab: the app opens a
 * canvas by navigating to its route, and the tab strip syncs a tab for the
 * active canvas — the same path rail rows and workspace cards take. Never a
 * browser tab. The one exception is the public share viewer, which lives on
 * another origin with no /canvas route, so it hands off to the app instead.
 */
export function useOpenCanvasLink() {
  const navigate = useNavigate();
  const isPublicCanvasView = useIsPublicCanvasView();
  return useCallback(
    (entity: CanvasEntity) => {
      if (isPublicCanvasView) {
        openCanvasEntityTabUrl(canvasLinkOpenUrl(entity));
        return;
      }
      navigate(route(ROUTES.CANVAS.DETAIL, { canvasId: entity.data.id }));
    },
    [isPublicCanvasView, navigate],
  );
}
